/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Photos: Image Card
 */

// Components
import ImgNextGen from '../../../../components/ImgNextGen';

// Styles
import './style.scss'

const ImageCard = (props) => {
    const {image} = props;

    return (
        <div className="image-card">
            <ImgNextGen
                srcWebp={image.srcWebp}
                fallback={image.src}
                alt={image.caption}
            />

            <div className="image-card__caption">
                <div className="image-card__category text-white-50">{image.header}</div>
                <div className="image-card__name">{image.caption}</div>
            </div>
        </div>
    );
};

export default ImageCard;
